import React from "react";
import {CatalogService} from "../../../service/catalog/CatalogService";
import PresvalDropDown from "../PresvalDropDownView";


export default class RentTypeDropDownContainer extends React.Component {
    constructor(props) {
        super(props);
        this.catalogService = new CatalogService();

        this.getRentTypeCatalog = this.getRentTypeCatalog.bind(this);

        this.state = {
            catRentTypeCatalog: this.getRentTypeCatalog(),
        };
    }

    getRentTypeCatalog() {
        this.catalogService.getRentTypeCatalog().then(
            res => {
                this.setState({
                    catRentTypeCatalog: res,
                });
                this.props.loading(false);
            }
        )
    }

    render() {
        return <PresvalDropDown
            name={this.props.name}
            filter={this.props.filter}
            options={this.state.catRentTypeCatalog}
            save={this.props.save}
            value={this.props.value}
        />
    }
};